import Link from "next/link";
import Newsletter from "../../components/Footer/components/Newsletter/Newsletter";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Hero from "../../components/Hero/Hero";

export default function FAQ() {
    return (
        <div>
            <Header />
            <Hero title="FAQ" subtitle="Često postavljana pitanja" />
            <article className="mt-16 mb-32 max-w-screen-lg mx-auto px-6 lg:px-0 prose prose-md space-y-4 leading-8">
                <h2 className="text-xl">Šta je Dzobs.com?</h2>
                <p>
                    Dzobs.com je web stranica koja nudi pristup bazi IT poslova
                    i iskustava o radu u IT firmama u Bosni i Hercegovini. Sve
                    funkcionalnosti Dzobs.com portala su besplatne, za
                    programere/IT ekipu će uvijek biti besplatne{" "}
                    <span className="text-red">♥</span>, a za firme
                    brainstormamo neke premium mogućnosti.
                </p>

                <h2 className="text-xl pt-6">
                    Da li su moja iskustva anonimna?
                </h2>
                <p>
                    Da. Sva iskustva koja ostaviš su 100% anonimna i nigdje i
                    nikada nećemo otkrivati tvoj identitet. Za detaljnije
                    informacije o privatnosti pogledaj{" "}
                    <Link href="/privatnost">
                        <a className="text-blue-dark">
                            Pravila o zaštiti privatnosti
                        </a>
                    </Link>
                    . Naravno, informacije koje ostavljate u komentaru ne bi
                    trebali sadržavati vaše lične informacije, odnosno, nemojte
                    biti{" "}
                    <a
                        href="https://www.youtube.com/watch?v=glZEVkBQzYM&t=86s"
                        target="_blank"
                        className="text-blue-dark"
                    >
                        Djuro.
                    </a>
                </p>

                <h2 className="text-xl pt-6">
                    Da li firme mogu da utiču na brisanje i promjenu komentara?
                </h2>
                <p>
                    Ne. Firme ni na koji način ne mogu da utiču na brisanje ili
                    promjenu komentara korisnika. Sa druge strane, osoba koja je
                    ostavila komentar može isti i obrisati u bilo kojem
                    trenutku. Čisto ako pomislite da smo mi obrisali neki spicy
                    komentar, nismo, šta inicijalno odobrimo, naknadno ne
                    brišemo.
                </p>

                <h2 className="text-xl pt-6">
                    Zašto moram da se registrujem da bih ostavio iskustvo o
                    firmi?
                </h2>
                <p>
                    Inicijalno jer je Goran htio da se igra sa OAuth 2.0 i
                    NextJS-om, a naknadno jer registracija smanjuje rizik od
                    zloupotreba sistema i povećava šansu da iza ostavljenih
                    iskustava stoji prava osoba, a ne bot. Bot može biti
                    pojedinac ili firma.
                </p>

                <h2 className="text-xl pt-6">
                    Koliko puta mogu da ostavim iskustvo za neku firmu?
                </h2>
                <p>Za istu firmu možeš ostaviti iskustvo jednom u 6 mjeseci.</p>

                <h2 className="text-xl pt-6">
                    Šta je dozvoljeno napisati prilikom ostavljanja iskustva?
                </h2>
                <p>
                    Možeš napisati sve ono što misliš da je važno za druge
                    korisnike kako bi saznali kako zaista izgleda rad u tvojoj
                    firmi. Nije dozvoljeno objavljivanje povjerljivih poslovnih
                    informacija kao što su finansijski podaci, podaci o
                    klijentima, imena zaposlenih, itd. Za više informacija
                    posjeti stranicu{" "}
                    <Link href="/smjernice">
                        <a className="text-blue-dark">
                            Smjernice za ostavljanje iskustava
                        </a>
                    </Link>
                    .
                </p>

                <h2 className="text-xl pt-6">
                    Da li mogu da izmjenim ili obrišem iskustvo?
                </h2>
                <p>
                    Iskustvo možeš da izmjeniš u roku od 24 sata od
                    objavljivanja, a u bilo kom trenutku možeš da ga obrišeš.
                </p>

                <h2 className="text-xl pt-6">
                    Predstavljam firmu, kako da dobijem pristup mojoj firmi?
                </h2>
                <p>
                    Dzobs.com trenutno radi na razvoju funkcionalnosti za
                    predstavnike firmi koje će omogućiti bolje predstavljanje i
                    komunikaciju sa korisnicima na portalu. Ukoliko želite
                    dobiti rani pristup,{" "}
                    <Link href="/kontakt">
                        <a className="text-blue-dark">kontaktirajte nas</a>
                    </Link>
                    .
                </p>
            </article>
            <Newsletter bg="bg-gray-light" />
            <Footer />
        </div>
    );
}
